import { IconButton, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Input as NBInput } from 'native-base';
import React from 'react';
import { NativeSyntheticEvent, TextInputChangeEventData } from 'react-native';

interface InputProps {
  handleSendMessage: () => Promise<void>;
  input: string;
  onChangeSetInput: (e: NativeSyntheticEvent<TextInputChangeEventData>) => void;
  messageIsSending: boolean;
  sendButtonIsDisabled: boolean;
}

export const Input: React.FC<InputProps> = ({
  handleSendMessage,
  input,
  onChangeSetInput,
  messageIsSending,
  sendButtonIsDisabled,
}) => {
  return (
    <Box w="full" px={Spacing['inline.xxxs']} pb={Spacing['inline.xxxs']}>
      <HStack
        alignItems="center"
        bg={Color['neutral.white']}
        borderTopWidth={1}
        space={Spacing['stack.nano']}
        borderTopColor={Color['neutral.lightest']}
        pt={Spacing['inline.xxxs']}>
        <NBInput
          padding={Spacing['stack.nano']}
          onSubmitEditing={handleSendMessage}
          fontSize={Typography['fontsize.lg']}
          flex={1}
          variant="unstyled"
          h="42px"
          autoFocus={true}
          value={input}
          placeholder="Digite sua mensagem"
          onChange={onChangeSetInput}
          isDisabled={messageIsSending}
        />
        <IconButton
          testId="send-message-button"
          onPress={handleSendMessage}
          borderRadius={BoxRadius.circular}
          w="40px"
          h="40px"
          bgColor="brand.tertiary.principal"
          iconColor={Color['neutral.white']}
          icon="Check"
          iconSize="xxs"
          isDisabled={sendButtonIsDisabled}
          {...(sendButtonIsDisabled && {
            bgColor: Utils.ColorToken.WithOpacity('brand.tertiary.principal', 1),
          })}
        />
      </HStack>
    </Box>
  );
};
